import { memo } from 'react';
import type { CellContext } from '@tanstack/react-table';
import { Avatar, Typography } from '@mui/material';
import { ColWrapper, StyledTypography, Wrapper } from './Username.styles';
import { isNull, isUndefined } from 'utils/typeChecks';

interface Props<T, P> {
  value: string;
  email?: string;
  row?: CellContext<T, P>;
  onClick?: (row: T, cell: keyof P) => unknown;
  isClickable?: boolean;
  className?: string;
}

export const UsernameBase = <T, P>({ value, email, row, onClick, isClickable, className }: Props<T, P>) => {
  const hasValue = !isNull(value) && !isUndefined(value) && String(value).trim().length > 0;

  const displayName = hasValue ? value : '';

  let initials = '';
  if (hasValue) {
    const vallArray = value.trim().split(' ');
    initials = vallArray[0].charAt(0) + (vallArray.length > 1 ? vallArray[vallArray.length - 1].charAt(0) : '');
  }

  const handleRowClick = () => {
    if (onClick && row) {
      onClick(row.row.original, row.column.id as keyof P);
    }
  };

  return (
    <Wrapper onClick={handleRowClick} className={className}>
      {value && (
        <Avatar sx={{ width: '24px', height: '24px' }}>
          <Typography variant="subtitle2">{initials}</Typography>
        </Avatar>
      )}
      {!email ? (
        <StyledTypography variant="subtitle2" hasValue={hasValue} isClickable={isClickable}>
          {displayName}
        </StyledTypography>
      ) : (
        <ColWrapper>
          <StyledTypography variant="subtitle2" hasValue={hasValue} isClickable={isClickable}>
            {displayName}
          </StyledTypography>
          <Typography variant="subtitle2" className="text-xs text-gray-500">
            {/*TODO className*/}
            {email}
          </Typography>
        </ColWrapper>
      )}
    </Wrapper>
  );
};

export const Username = memo(UsernameBase) as typeof UsernameBase;
